import { ProjectAssets, ImageAssets, VideoAssets, DownloadAssets } from '@models';
import * as Download_01 from './dino_epoch_v1.01.zip';

export const Title: ImageAssets = {
    
};

export const Images: ImageAssets = {
    
};

export const Videos: VideoAssets = {
};

export const Downloads: DownloadAssets = {
    Download_01
};

const DinoQuest: ProjectAssets = {
    Title,
    Images,
    Videos,
    Downloads
};

export default DinoQuest;